<template>
    <div class="text-center">
      <v-dialog v-model="dialog" max-width="700" persistent>
        <v-card>
          <v-card-title class="text-h5 blue darken-3 white--text">
            Su clave no es segura
          </v-card-title>
  
          <v-card-text>
            <p class="mb-0 mt-4">
                Con el fin de garantizar la seguridad de su cuenta, le solicitamos que cambie su contraseña de inicio de sesión ya que actualmente, está utilizando su número de documento de identidad como contraseña por defecto, al igual que los demás usuarios.
            </p> 
            <p>
                Esto implica un alto riesgo de vulnerabilidad, ya que terceros podrían acceder a su cuenta con facilidad.
            </p>
            <p>
                Por lo tanto, le recomendamos encarecidamente que modifique su contraseña lo antes posible para evitar cualquier riesgo de seguridad.
            </p>
            <p>
                Recuerde que la seguridad de su información personal es de suma importancia para nosotros y esperamos que tome las medidas necesarias para garantizar la protección de su cuenta.
            </p> 
          </v-card-text>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="cerrar()">
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </template>
  
  <script>
  
    export default {
      data() {
        return {
          loading: true,
          dialog: false,
          msg: '',
          convenios: [],
        };
      },
      methods: {
        openmodal() {
          this.msg = '';
          this.dialog = true;
          
        },
        cerrar() {
            window.sessionStorage.setItem( 'xperfil',JSON.stringify( this.$store.state.DATA_USER ) );
            this.$router.push({name:'perfil'});
            this.dialog = !this.dialog;
        },
      },
    };
  </script>
  